module.exports = __webpack_public_path__ + "img/courses.19105b53.svg";